import { useQuery } from "@tanstack/react-query";

import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";

type StoredToken = {
  AccessToken?: string;
};

export type BetLimitsTierResponse = {
  tier?: string;
  [key: string]: unknown;
} | null;

const fetchBetLimitsTier = async (
  user_id: string,
): Promise<BetLimitsTierResponse> => {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString
    ? JSON.parse(tokenString)
    : null;
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken,
  );

  const response = await PrivateAdminPanelInstance.get(
    API_ROUTES.GET_USER_BET_LIMITS_TIER.replace("{user_id}", user_id),
  );

  return response?.data ?? null;
};

export const useGetBetLimitsTier = (user_id?: string | null) =>
  useQuery<BetLimitsTierResponse, Error>({
    queryKey: ["betLimitsTier", user_id],
    queryFn: () => fetchBetLimitsTier(user_id as string),
    enabled: Boolean(user_id),
    staleTime: 0,
    refetchOnWindowFocus: false,
  });
